<template>
  <div id="select">
    <div class="list-box">
      <div class="choose">
        <div class="item"> 
          <template v-if="$store.state.isMobile==false">
            产品分类：
            <el-select
            :size="$store.state.isMobile ? 'mini' : 'small'"
            v-model="choose"
            clearable
            placeholder="请选择分类"
          >
            <el-option
              v-for="item in options"
              :key="item.cat_id"
              :label="item.name"
              :value="item.cat_id"
            >
            </el-option>
          </el-select>
          </template>
          

          <div class="keyword">
            <el-input class="inputwidth" :size="$store.state.isMobile ? 'mini' : 'small'" v-model="keyword" placeholder="请输入内容"></el-input>
             <el-button
             style="margin-left:10px"
            @click="search"
            type="primary"
            :size="$store.state.isMobile ? 'mini' : 'small'"
            icon="el-icon-search"
            >搜索</el-button
          >
          </div>
        </div>

         <div>
          <el-button
            @click="kefu"
            type="primary"
            :size="$store.state.isMobile ? 'mini' : 'small'"
            icon="el-icon-s-goods"
            >我要供货</el-button
          >
        </div>

       

       
      </div>

      <div class="Selection" v-infinite-scroll="load">
        <el-row
          class="flex"
          :gutter="$store.state.isMobile ? 10 : 20"
          v-loading="loading"
        >
          <el-col
            :span="$store.state.isMobile ? 12 : 6"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="grid-content bg-purple item">
              <img v-lazy="item.pic1" ref='pic' :alt="item.title" />
              <div class="price">
                <span>{{ item.jiage }}元</span>
                <el-tag type="danger" size="mini">包邮</el-tag>
              </div>
              <h6>{{ item.title }}</h6>
              <div class="shop">
                <i class="el-icon-s-shop"></i>
                <span>{{ item.shopname }}</span>
              </div>
              <div class="btn">
                <el-button
                  type="danger"
                  @click="add(item.source)"
                  icon="el-icon-sell"
                  :size="$store.state.isMobile ? 'mini' : 'small'"
                  >铺货</el-button
                >
                <el-button
                  @click="open(item.source)"
                  icon="el-icon-plus"
                  type="danger"
                  plain
                  :size="$store.state.isMobile ? 'mini' : 'small'"
                  >采购</el-button
                >
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="back">
         <el-button type="primary" @click="back" v-show='searchStatus' round>返回列表</el-button>
      </div>

    </div>
  </div>
</template>
<style lang="css" >
@media screen and (max-width: 750px) {
  .el-select .el-input__inner {
    padding: 0 10px !important;
    width: 130px;
  }
  #select {
    height: 96%;
  }
  .inputwidth{
    flex: 1;
  }
  .keyword{
    padding-left: 0!important;
  }

}
.inputwidth{
  width: 40%;
}
.back{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.choose .item{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.choose .item .keyword{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  padding: 0 14px;
}
</style>
<script>
export default {
  name: "Selection",
  data() {
    return {
      list: [],
      options: [],
      choose: "",
      page: 1,
      more: true,
      loading: true,
      keyword: "",
      searchStatus:false,
    };
  },
  methods: {
    kefu() {
      this.$store.commit("changekefu");
    },
    back(){
      this.searchStatus=false;
      this.page=1;
       this.more=true;
       this.keyword='';
       this.getList();

    },
    getType() {
      this.axios.get(this.api.recommendChoose).then(res => {
        this.options = res;
      });
    },
    load() {
      this.page += 1;
      if (this.choose) {
        this.getList(this.choose);
      } else {
        this.getList();
      }
    },
    getList(fenlei = "") {
      if (this.more == true) {
        this.loading = true;
        this.axios
          .get(this.api.recommend, {
            params: {
              fenlei,
              page: this.page,
              daili_id:this.daili_id?this.daili_id:''
            }
          })
          .then(res => {
            this.loading = false;
            if (res.list == "") {
              this.more = false;

              if (this.page == 1) {
                this.$message({
                  message: "暂无内容",
                  type: "warning"
                });
              } else {
                this.$message({
                  message: "已经到底了",
                  type: "warning"
                });
              }
            } else {
              if (this.page != 1) {
                this.list = this.list.concat(res.list);
              } else {
                this.list = res.list;
              }
            }
          });
      }
    },


    search(){
      

       if(this.keyword!=''){
          this.loading = true;
          this.page=1;
          this.axios
          .get(this.api.recommend, {
            params: {
              keyword:this.keyword
            }
          })
          .then(res => {
            this.loading = false;
            if (res.list == "") {
              this.more = false;
              if (this.page == 1) {
                this.$message({
                  message: "暂无内容",
                  type: "warning"
                });
              } else {
                this.$message({
                  message: "已经到底了",
                  type: "warning"
                });
              }
            } else {
              this.searchStatus=true;
              if (this.page != 1) {
                this.list = this.list.concat(res.list);
              } else {
                this.list = res.list;
              }
             
           
               
            }
          });
       }else{
          this.$message({
                  message: "请输入关键词",
                  type: "warning"
                });
       }
       
    },

    add(id) {
      this.$store.commit("addProductId", id);
      this.$store.commit("alertChange");
    },

    open(id) {
      // const _this = this;
      this.$alert(
        `<img style='width:200px;height:200px;display:block;margin:0 auto' src='/addons/yumi_dianqun/temp/ewm/${id}.png' >`,
        "采购",
        {
          dangerouslyUseHTMLString: true,
          showClose: false
          // beforeClose( done) {

          //   done();
          // }
        }
      );
    }
  },
  created() {
    if(this.$store.state.userinfo.fromshopname&&this.$store.state.userinfo.gzhucid){
      this.daili_id=this.$store.state.userinfo.gzhucid
    }
    this.getType();
    this.getList();
  },
  mounted() {
    //  pic

   
   
  },
  watch: {
    choose: function(id) {
      this.more = true;
      this.list = [];
      this.page = 1;
      this.getList(id);
    }
  }
};
</script>